import React from 'react';
import {TextField} from '@mui/material';

export function FormikTextField({formik, name, maxLength, onChange, ...props}) {
    return (
        <>
            <TextField
                id={name}
                name={name}
                value={formik?.values?.[name] || ''}
                onChange={onChange ? onChange : formik.handleChange}
                error={Boolean(formik.touched[name] && formik.errors[name])}
                helperText={formik.touched[name] && formik.errors[name]}
                inputProps={{maxLength}}
                onInput={(e) => {
                    if (props.type === 'number') {
                        e.target.value = e.target.value.replace(/[eE+-]/g, '');
                    }
                }}
                {...props}
            />
            {props.multiline && maxLength &&
                <span style={{
                    textAlign: 'right',
                    display: 'block',
                    fontSize: 12,
                    marginTop: formik.touched.answer && formik.errors.answer ? -20 : 0,
                    opacity: props.disabled ? 0.5 : 1,
                }}>
                    {formik?.values?.[name].length}/{maxLength}
                </span>
            }
        </>

    );
}
